import { getRoomPrice } from '@koob/utils';

export interface HotelStayRoomsAvailability {
  cheapestRooms?: any[];
}

interface HotelStayRoomSelection {
  allRooms?: any[];
  isUnavailable?: boolean;
  // Only read for the `isUnavailable` case — a room selection restored from
  // a draft whose rooms are gone carries no bed data to read a currency off.
  currency?: string;
}

export interface HotelStayPrice {
  price: number;
  currency?: string;
}

function currencyOf(rooms: any[] | undefined): string | undefined {
  const bed = rooms?.[0]?.bed ?? rooms?.[0]?.bedChoices?.[0];
  return bed?.currency;
}

// The price of a hotel stay: the rooms actually selected for it, or the
// cheapest the availability offers when nothing has been chosen yet. A
// selection restored from a draft whose rooms are no longer available prices
// at NaN — a rate discounted to exactly 0 is still a real, bookable price;
// only the absence of one reads as unavailable (see ComposeDayHotel's own
// `hasBookablePrice` comment, same rule).
export function priceHotelStay(
  roomsAvailability: HotelStayRoomsAvailability | null | undefined,
  roomSelection: HotelStayRoomSelection | null | undefined,
  nights: number,
): HotelStayPrice | null {
  if (!nights) return null;

  if (roomSelection?.isUnavailable) {
    return { price: NaN, currency: roomSelection.currency };
  }

  const rooms = roomSelection?.allRooms?.length
    ? roomSelection.allRooms
    : roomsAvailability?.cheapestRooms;

  if (!rooms?.length) return null;

  return {
    price: rooms.reduce((sum, room) => sum + getRoomPrice(room), 0),
    currency: currencyOf(rooms),
  };
}
